import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../config';
import { ScreenStore } from '../../stores/ScreenStore';
import { CHECKOUT_STAGES } from '../../stores/CheckoutStore';
import { AppLink, routeNaming } from '../../routes';
import { ProgressBullet, BULLET_TYPES, BULLET_STATUSES } from './progress-bullet';
import cgLogo from '../../assets/images/cg-logo.svg';
import styles from './CheckoutNavbar.css';

const bulletOptions = [
  {
    label: 'Carrito',
    // Cart can never be enabled, thus it has no id
    ids: [null],
  },
  {
    label: 'Dirección de envío',
    ids: [CHECKOUT_STAGES.CHOOSE_ADDRESS],
  },
  {
    label: 'Opciones de envío',
    ids: [
      CHECKOUT_STAGES.SHIPPING_OPTIONS,
      CHECKOUT_STAGES.INSTALLATION_OPTIONS,
    ],
  },
  {
    label: 'Facturación',
    ids: [CHECKOUT_STAGES.BILLING_OPTIONS],
  },
  {
    label: 'Resumen',
    ids: [CHECKOUT_STAGES.CONFIRM_CHECKOUT],
  },
];

const IPropTypes = {
  currentStage: PropTypes.oneOf(Object.values(CHECKOUT_STAGES)).isRequired,
};

const CheckoutNavbar = (props) => {
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
  let activeBulletSeen = false;
  const progressBullets = bulletOptions.map((option, index, array) => {
    let status = BULLET_STATUSES.DISABLED;
    if (activeBulletSeen) {
      status = BULLET_STATUSES.NORMAL;
    }
    if (option.ids.includes(props.currentStage)) {
      status = BULLET_STATUSES.ACTIVE;
      activeBulletSeen = true;
    }
    let position = BULLET_TYPES.CENTER;
    if (index === 0) {
      position = BULLET_TYPES.LEFT;
    }
    if (index === array.length - 1) {
      position = BULLET_TYPES.RIGHT;
    }
    return (
      <ProgressBullet
        key={option.ids[0]}
        label={option.label}
        status={status}
        bulletType={position}
      />
    );
  });
  return (
    <nav className={styles.container}>
      <div className={styles.navbarContainer}>
        <div className={styles.navbar}>
          {
            !mobileVersion &&
            <div className={styles.leftContainer}>
              <AppLink
                className={styles.logoLink}
                routeName={routeNaming.HOME}
              >
                <img
                  alt=""
                  src={cgLogo}
                />
              </AppLink>
            </div>
          }
          {
            !mobileVersion &&
            <div className={styles.rightContainer}>
              {progressBullets}
            </div>
          }
          {
            mobileVersion &&
            <div className={styles.topNavbar}>
              <div className={styles.logoContainer}>
                <AppLink
                  className={styles.logoLink}
                  routeName={routeNaming.HOME}
                >
                  <img
                    alt=""
                    src={cgLogo}
                  />
                </AppLink>
              </div>
            </div>
          }
        </div>
        {
          false &&
          <div className={styles.mobileMenuContainer}>
            <div className={styles.bulletContainer}>
              {progressBullets}
            </div>
          </div>
        }
      </div>
    </nav>
  );
};

CheckoutNavbar.propTypes = IPropTypes;

const ObservedCheckoutNavbar = observer(CheckoutNavbar);

export { ObservedCheckoutNavbar as CheckoutNavbar };



// WEBPACK FOOTER //
// ./src/common/checkout-navbar/CheckoutNavbar.jsx